import {Form} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function FormItemBizProp({Model, prop, ...props}) {
    const map = useMapContext()
    const model = new Model(map)
    const label = model.name(null, prop)

    return (
        <Form.Item
            label={label}
            name={prop}
            {...props}
        />
    )
}
